module.exports = __webpack_public_path__ + "static/nato-chart-b5988fbc9e9d375cd9443192d93da7bd.png";